module.exports = __webpack_public_path__ + "img/Icon-survey-Calendar.ccb92146.svg";